(function () {
    'use strict';

    angular
        .module('app.shared')
        .service('adminClubPickerData', adminClubPickerData);

    var copy = angular.copy;

    adminClubPickerData.$inject = ['$q', '$rootScope', '$transitions', 'user', 'Club', 'defaultAdminClubSearchPageSize'];
    function adminClubPickerData($q, $rootScope, $transitions, user, Club, pageSize) {
        var result = {},
            current;

        Object.defineProperty(result, 'refresh', { value: refresh }); // <== otherwise the angular.copy will erase it
        activate();
        return result;
        
        // Init
        function activate() {
            $rootScope.$watch(userWatch, userWatchAction);
            $transitions.onStart({ to: isAdminState }, transitionWatchAction);

            function isAdminState(state) {
                return state.data && state.data.requireAdmin || false;
            }
        }

        // Watches
        function userWatch() {
            return user.id;
        }
        function userWatchAction(newValue, oldValue) {
            copy({}, result); // <== Clear data
        }
        function transitionWatchAction(transition) {
            return result.$initialized || refresh();
        }

        // Methods
        function refresh(text) {
            var adminId = user.isAdmin && user.id;
            if (current)
                current.$cancelRequest();
            return adminId ? (current = Club.getAdminClubs(params(), success)).$promise : $q.reject();

            function params() {
                return { individualId: adminId, $skip: 0, $top: pageSize, $filter: { search: text } };
            }
            function success(response) {
                copy(response, result);
                result.$initialized = true;
                return result;
            }
        }
    }
})();
